import axios from "axios";

const fetchBillDetailsWithBillId = async (billId) => {
    const response = await axios.post(
        `${process.env.REACT_APP_LAWS_BACKEND_HOST}/bills/v1/bills/search`,
        { billIds: [billId] },
        {
            params: {
                limit: 1,
                offset: 0,
                includeCounts: false,
                sort: 'billType.sortOrder,desc'
            }
        }
    );
    return response.data.content[0];
};

export default fetchBillDetailsWithBillId;